import { EventBus } from '../../helpers/event-bus'

export default {

  install (Vue) {
    Vue.prototype.$eventBus = EventBus
  }
}



// WEBPACK FOOTER //
// ./src/services/eventbus/index.js